(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('specimen', {
                parent: 'entity',
                url: '/specimen',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Specimen'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/specimen/list/specimen.html',
                        controller: 'SpecimenController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access);
                }]
            });
    }
})();
